<template>
  <v-container class="pa-8">
    <span class="title font-weight-bold">Contact Us</span>
    <v-divider class="my-9" style="width: 90%"></v-divider>
    <v-row :class="{ 'ml-10': !$vuetify.breakpoint.xs }">
      <v-col cols="auto" class="pa-7 mr-10">
        <v-icon size="32" class="custom-text">mdi-cellphone-iphone</v-icon>
        <p class="mb-3 custom-text font-weight-bold display-1 ubuntu">Give us a call</p>
        <span style="color: #4d4d4d" class="ubuntu">
          For support, please dial
          <span class="font-weight-bold ubuntu">+ 1 (786) 661 0342</span>
        </span>
        <v-divider class="my-8"></v-divider>
        <v-icon size="32" class="custom-text">mdi-email</v-icon>
        <p class="mb-1 display-1 custom-text ubuntu font-weight-bold">Email</p>
        <span style="color: #4d4d4d" class="ubuntu">info@archeslanguage.com</span>
      </v-col>
      <v-col cols="auto">
        <v-card class="half-radius shadow pa-6">
          <v-card-title
            class="headline font-weight-bold custom-text ubuntu"
            style="word-break: normal"
            >Please, fill out the form and one of our representatives will get in touch with
            you.</v-card-title
          >
          <v-card-subtitle class="custom-subtitle font-weight-light ubuntu"
            >Please complete the form to contact you back</v-card-subtitle
          >
          <v-row class="px-4">
            <v-col cols="12">
              <v-form ref="form">
                <span class="body-2 ubuntu" style="color: #43425d">Subject</span>
                <v-card class="mb-4 mt-2 shadow half-radius">
                  <v-text-field flat solo hide-details v-model="crud.subject">
                    <template #append>
                      <v-fade-transition>
                        <v-icon v-if="success" color="success" right> mdi-check-all </v-icon>
                      </v-fade-transition>
                    </template>
                  </v-text-field>
                </v-card>
                <span class="body-2 ubuntu" style="color: #43425d">Message</span>
                <v-card class="mt-4 shadow half-radius">
                  <v-textarea
                    flat
                    solo
                    auto-grow
                    v-model="crud.content"
                    :rules="[(v) => !!v || 'Message body required...']"
                  />
                </v-card>
              </v-form>
            </v-col>
            <v-btn
              class="mx-auto white--text my-10 ubuntu text-capitalize"
              height="50"
              width="185"
              depressed
              :loading="loading"
              color="#FF347C"
              @click="onSubmit"
              style="font-size: 18"
              >Submit</v-btn
            >
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { postMessage } from "@/api/api";

export default {
  data() {
    return {
      crud: {
        content: "",
        subject: "",
      },
      loading: false,
      success: false,
    };
  },
  methods: {
    async onSubmit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        await postMessage(this.crud);
        this.success = true;
        setTimeout(() => {
          this.success = false;
        }, 5000);
      } catch (error) {
        this.$store.commit("updateSnackbar", {
          statusText: "Error submmiting message",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.custom-subtilte {
  color: #a7a6ad;
}
.ubuntu {
  font-family: Ubuntu !important;
}
</style>
